import { loadRecaptchaScript, executeRecaptcha } from '@/util/recaptcha';
import { RECAPTCHA_V2_REQUIRED } from '@/dao/dao';

export default {
  data() {
    return {
      showV2Challenge: false,
      _v2Resolver: null,
      _v2Rejecter: null
    };
  },
  computed: {
    recaptchaSiteKey() {
      return (this.$store.getters.meta || {}).recaptchaSiteKey || '';
    },
    recaptchaV2SiteKey() {
      return (this.$store.getters.meta || {}).recaptchaV2SiteKey || '';
    }
  },
  methods: {
    loadRecaptcha() {
      return loadRecaptchaScript(this.recaptchaSiteKey);
    },
    _waitForV2Token() {
      this.showV2Challenge = true;
      return new Promise((resolve, reject) => {
        this._v2Resolver = resolve;
        this._v2Rejecter = reject;
      });
    },
    onV2Resolved(token) {
      const resolver = this._v2Resolver;
      this._v2Resolver = null;
      this._v2Rejecter = null;
      if (resolver) resolver(token);
    },
    onV2Cancelled() {
      const rejecter = this._v2Rejecter;
      this._v2Resolver = null;
      this._v2Rejecter = null;
      if (rejecter) rejecter(new Error('reCAPTCHA challenge cancelled'));
    },
    onV2Error(err) {
      const rejecter = this._v2Rejecter;
      this._v2Resolver = null;
      this._v2Rejecter = null;
      if (rejecter) rejecter(err || new Error('reCAPTCHA error'));
    },
    // Submit a request that requires reCAPTCHA. *fn* receives a `tokens` object
    // ({recaptcha_token, recaptcha_v2_token?}) and is invoked once with v3, and
    // a second time with the v2 token if the backend requested the fallback.
    async submitWithRecaptcha(action, fn) {
      await this.loadRecaptcha();
      const recaptchaToken = await executeRecaptcha(this.recaptchaSiteKey, action);
      try {
        return await fn({ recaptcha_token: recaptchaToken });
      } catch (error) {
        if (!error || error.code !== RECAPTCHA_V2_REQUIRED) throw error;
        if (!this.recaptchaV2SiteKey) throw error;
        const v2Token = await this._waitForV2Token();
        return await fn({ recaptcha_token: recaptchaToken, recaptcha_v2_token: v2Token });
      }
    }
  }
};
